import ImageMeta from 'components/meta/ImageMeta'
import { useOmensPageSeo } from 'components/meta/OmensSeoHead'
import Head from 'next/head'
import { FC } from 'react'
import config from 'utils/siteConfig'

interface CharlesMetaProps {
  data?: {
    title?: string
    feature_image?: string
    description?: string
    bio?: string
    profile_image?: string
    meta_description?: string
    meta_title?: string
    name?: string
  }
  canonical?: string
  title?: string
  description?: string
  image?: string
  type?: 'WebSite' | 'Series'
}

const CharlesMeta: FC<CharlesMetaProps> = ({ data, canonical, title, description, image }) => {
  // Omens pages: the registry's title, description and canonical (modules/omensSeoTechnical/pages.ts), the
  // same values _app already put in the server HTML.
  const omensSeo = useOmensPageSeo()
  const shareImage = new URL(image || (data && data?.feature_image) || config.shareImage, config.siteUrl).href

  description =
    omensSeo?.description ||
    description ||
    data?.meta_description ||
    data?.description ||
    config.siteDescriptionMeta ||
    config.siteDescriptionMeta
  title = omensSeo?.title || title || data?.meta_title || data?.name || data?.title || config.siteTitleMeta
  canonical = omensSeo?.canonicalUrl || canonical

  return (
    <>
      <Head>
        <title key="title">{title}</title>
        <meta key="description" name="description" content={description} />
        {canonical && <link key="canonical" rel="canonical" href={canonical} />}
        <meta key="og:site_name" property="og:site_name" content={config.siteName} />
        <meta key="og:type" property="og:type" content="website" />
        <meta key="og:title" property="og:title" content={title} />
        <meta key="og:description" property="og:description" content={description} />
        <meta key="og:locale" property="og:locale" content="pt_BR" />
        {canonical && <meta key="og:url" property="og:url" content={canonical} />}
        <meta key="twitter:title" name="twitter:title" content={title} />
        <meta key="twitter:description" name="twitter:description" content={description} />
        {canonical && <meta key="twitter:url" name="twitter:url" content={canonical} />}
        <meta name="twitter:site" content={`https://twitter.com/${config.twitter.replace(/^@/, '')}/`} />
        <meta name="twitter:creator" content={config.twitter} />
        <meta
          key="facebook-domain-verification"
          name="facebook-domain-verification"
          content={config.facebookDomainVerification}
        />
      </Head>
      <ImageMeta image={shareImage} />
    </>
  )
}

export default CharlesMeta
